import React, { useEffect, useState, useMemo } from "react";
import { firebaseAdmin } from "firebaseAdmin";
import * as analytics from "utils/analytics";
import safeJsonStringify from 'safe-json-stringify';
import { TrendingTopic } from "components/generate-canva/trending-topic";

const Topic = ({ topic, tweets, topics, topicFull }) => {

    const [refresh, refresher] = React.useState({});
    
    let title = "Trending tweets about " + topic;
    let subtitle = `Explore this list of trending tweets related to ${topic} in the last 30 days. Check them out to know what's hot right now.`;
    let desc = `Explore this list of the trending tweets related to ${topic} in the last 30 days. Check them out to know what's hot right now.`;
    let url = "https://tweethunter.io/trending/" + topic;
    let image = `https://ondemand.bannerbear.com/simpleurl/eN6mLGkQNNed9zbP2O/image/title/text/Top%Trending%20Tweets%20about${topic}`;

    return (
        <TrendingTopic
            topic={topic}
            topicFull={topicFull}
            title={title}
            subtitle={subtitle}
            desc={desc}
            url={url}
            image={image}
            tweets={tweets}
            suggestions={topics}
        />
    );
};

export async function getStaticPaths() {

    // let urlTopics = "https://us-central1-ez4cast.cloudfunctions.net/tweetListening-getTrendingTopic?mode=Monthly&topic=startup&nbTweets=1";
    let urlTopics = "https://us-central1-ez4cast.cloudfunctions.net/tweetListening-getTrending?isRelative=0&mode=Monthly&sorting=slopeLike&count=20&nbTweets=0";
    const responseTopics = await fetch(urlTopics);
    const jsonTopics = await responseTopics.json();
        
    // console.log('jsonTopics:', jsonTopics?.data?.topics)
        
    // Get the paths we want to pre-render based on posts
    const paths = jsonTopics?.data?.topics?.slice(0, 20)?.map((t) => ({
        params: { topic: t.topicWord ?? t?.topic?.split(" | ")[0] },
    }));

    // console.log('trending paths:', paths);

    // We'll pre-render only these paths at build time.
    // { fallback: blocking } will server-render pages
    // on-demand if the path doesn't exist.
    return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params }) {
// export async function getServerSideProps({ params, res }) {

    console.log(params);
    analytics.log("visit_trending_topic", { topic: params?.topic });

    
    let url = "https://us-central1-ez4cast.cloudfunctions.net/tweetListening-getTrendingTopic?mode=Monthly&topic=" + params?.topic;
    const response = await fetch(url);
    const json = await response.json();

    if (!json?.data?.topic) {
        return {props: {tweets: [], topic: params?.topic, topics: []}};
    }
    
    // console.log('json:', json);
    let {topic, topicsList} = json.data;   
    let tweets = topic?.tweets;

    topic.freqTime = topic?.freqTime?.reverse();
    
    console.log('topicsList:', topicsList)
    let suggestions = topicsList.map(t => {
        let topicWord = t.split(" | ")[0];
        return {label: topicWord, key: topicWord};
    })
    // console.log('data:', data);

    let props = {
        tweets,
        topic: params?.topic,
        topicFull: topic,
        topics: suggestions,
    };

    const stringifiedData = safeJsonStringify(props);
    props = JSON.parse(stringifiedData);

    // res.setHeader('Cache-Control', 'public, max-age=86400, stale-while-revalidate=2592000'); // 1 days - 30 days

    return {
        props: props,
        revalidate: 86400, // 24 hours - In seconds
    };
}

export default Topic;
